export default function(task){
  if(task && task.taskType) {
    return `[${task.taskType.description}] ${task.description}`
  }
}



// WEBPACK FOOTER //
// ./src/utils/getTaskTitle.js